import React, { memo, useEffect, useCallback, useMemo } from 'react';
import { FormBase } from '../../components';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import strings from '../../globalization';
import { reduxForm, Field, initialize, reset } from 'redux-form';
import {
  CAT_SOFTWARE_VERSION_FORM,
  catSoftwareVersionForm,
  catSoftwareVersionFormReset
} from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert2';
const RenderInput = ({ input, meta, ...rest }) => (
  <Input
    {...input}
    {...rest}
    invalid={meta.touched && meta.error ? true : false}
  />
);
const RenderCheckbox = ({ input, meta, ...rest }) => (
  <Input
    {...input}
    {...rest}
    type="checkbox"
    checked={!!input.value}
    disabled={input.value}
    className="ms-0"
    style={{
      margin: 0,
      width: '1.25rem',
      height: '1.25rem',
      cursor: 'pointer'
    }}
  />
);
const CATSoftwareVersionForm = memo(props => {
  const history = useHistory();
  const { params } = props.match;
  const dispatch = useDispatch();
  const {
    data: initialValues = {},
    success,
    info,
    CustomError,
    err
  } = useSelector(state => state.catSoftwareVersionFormData.data);
  const shouldGoBack = useMemo(
    () =>
      success &&
      [
        'RecordSavedSuccessfully',
        'RecordUpdatedSuccessfully',
        'DeleteSuccess'
      ].includes(info),
    [success, info]
  );
  useEffect(() => {
    if (shouldGoBack) {
      dispatch(catSoftwareVersionFormReset());
      history.push({ pathname: `/catsoftwareversion` });
    }
  }, [shouldGoBack]);
  useEffect(() => {
    dispatch(initialize('CATSoftwareVersion', initialValues));
  }, [dispatch, initialValues]);
  useEffect(() => {
    dispatch(
      catSoftwareVersionForm({
        action: 'load',
        _id: params.id
      })
    );
  }, []);
  useEffect(() => {
    if (CustomError && err) {
      swal
        .fire({
          title: err,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        })
        .then(result => {
          if (result.isConfirmed) {
            dispatch(
              catSoftwareVersionForm({
                action: 'otherAction',
                otherAction: 'UpdateCATSoftwareVersion',
                Id: params.id,
                Data: initialValues
              })
            );
          } else {
            dispatch(
              initialize('CATSoftwareVersion', {
                ...initialValues,
                IsDefault: false
              })
            );
          }
        });
    }
  }, [CustomError]);
  const onSubmit = useCallback(values => {
    dispatch(
      catSoftwareVersionForm({
        action: params.id.toLowerCase() === 'new' ? 'add' : 'update',
        ...values,
        tableName: 'CATSoftwareVersion'
      })
    );
  }, []);
  return (
    <FormBase
      {...props}
      initialValues={initialValues}
      err={err}
      isDark={props.isDark}
      title={strings.CatSoftwareVersion}
      subTitle={initialValues.CATSoftwareVersion}
      onSubmit={onSubmit}
      actionInfo={{
        action: catSoftwareVersionForm,
        actionName: CAT_SOFTWARE_VERSION_FORM
      }}
      onFormCancel={() => history.push('/catsoftwareversion')}
    >
      <Row style={{ width: '100%' }}>
        <Col sm="12">
          <FormGroup row>
            <Label for="CATSoftwareVersion" sm={4} className="col-form-label">
              {strings.CatSoftwareVersion}
            </Label>
            <Col sm={8}>
              <Field
                name="CATSoftwareVersion"
                component={RenderInput}
                type="text"
                placeholder={strings.CatSoftwareVersion}
                maxLength={20}
              />
            </Col>
          </FormGroup>
        </Col>
        <Col sm="12">
          <FormGroup row>
            <Label for="IsDefault" sm={4} className="col-form-label">
              {strings.Default}
            </Label>
            <Col sm={8} className="d-flex align-items-center">
              <Field
                name="IsDefault"
                component={RenderCheckbox}
                type="checkbox"
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </FormBase>
  );
});
export default reduxForm({
  form: 'CATSoftwareVersion'
})(CATSoftwareVersionForm);
